// extracted by mini-css-extract-plugin
export var fadeIn = "_91-0";
export var panelInner = "_91-2";
export var panelOuter = "_91-1";